module.exports = __webpack_public_path__ + "b87944de37667dc441641b54f5fa2071.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/6_0.jpg
// module id = 306
// module chunks = 0